module.exports = __webpack_public_path__ + "img/pic1.ba4d26b4.png";